export default "__VITE_ASSET__cb6445ad__"